import { useState } from "react";
import { API_URL } from "../../../utils/common";

export interface AddPermisoRequest {
    nombre: string;
    descripcion: string;
    sufijo: string;
    estatus: string;
}

export const useAddUsuarioPermiso = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const getToken = () => localStorage.getItem("jwt");

    const agregarPermiso = async (
        payload: AddPermisoRequest
    ): Promise<boolean> => {

        setLoading(true);
        setError(null);

        try {

            const token = getToken();

            if (!token) {
                throw new Error("Token no encontrado");
            }

            const response = await fetch(
                `${API_URL}/cms/admin/permisos`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            if (!response.ok) {

                const data = await response.json().catch(() => null);

                throw new Error(
                    data?.message ??
                    "Error al registrar el permiso"
                );

            }

            return true;

        } catch (err: any) {

            console.error(err);

            setError(
                err.message || "Ocurrió un error"
            );

            return false;

        } finally {

            setLoading(false);

        }

    };

    return {

        agregarPermiso,
        loading,
        error,

    };

};